import React, { useState } from "react";
import { Popover } from "@material-ui/core";
import TextField from "@material-ui/core/TextField/TextField";
import CircleButtonsGroup from "../../../common/buttons/CircleButtonsGroup";
import { isIntegerString } from "../../../../utils/validationUtils";
import { loadRosLines, saveOrUpdateRosLine } from "../../../../actions/rosLinesActions";
import { useDispatch } from "react-redux";

export default function RosLineEditPopover({ button, tooltip, label, onOpenCallback, afterSaveCallback }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [rosLineData, setRosLineData] = useState({});
    const [fieldErrors, setFieldErrors] = useState({});
    const dispatch = useDispatch();

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
        onOpenCallback && onOpenCallback();
    };

    const handleSave = () => {
        const valid = isValid();
        if (valid) {
            handleClose();
            const body = {
                lineId: rosLineData.lineId,
                name: rosLineData.name,
                line: rosLineData.line
                    .split(/[\n,]+/) // Разделяем по запятой или новой строке
                    .map(item => item.trim())
                    .filter(item => item !== "") // Удаляем пустые элементы
                    .map(item => parseFloat(item)),
            };
            dispatch(saveOrUpdateRosLine(body, () => dispatch(loadRosLines(false, () => afterSaveCallback()))));
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
        setRosLineData({});
    };

    const handleTextTyping = (e) => {
        setRosLineData(
            { ...rosLineData, [e.target.name]: e.target.value }
        );
        setFieldErrors({ ...fieldErrors, [e.target.name]: null });
    };

    const isValid = () => {
        let isValid = true;
        let errors = {};
        if (!rosLineData.lineId) {
            errors = { ...errors, lineId: "Введите значение Line ID" };
            isValid = false;
        } else if (!isIntegerString(rosLineData.lineId)) {
            errors = { ...errors, lineId: "Line ID должно быть целым числом" };
            isValid = false;
        }
        if (!rosLineData.name) {
            errors = { ...errors, name: "Введите название" };
            isValid = false;
        }
        if (!rosLineData.line) {
            errors = { ...errors, line: "Введите точки" };
            isValid = false;
        } else if (!isLineValid()) {
            errors = { ...errors, line: "Поле должно содержать числа, разделенные запятыми или переносом строки" };
            isValid = false;
        }
        setFieldErrors({ ...fieldErrors, ...errors });
        return isValid;
    };

    const isLineValid = () => {
        if (!rosLineData.line) {
            return false;
        }
        const lineArr = rosLineData.line
            .split(/[\n,]+/) // Разделяем по запятой или новой строке
            .map(item => item.trim())
            .filter(item => item !== ""); // Удаляем пустые элементы
        if (!lineArr || lineArr.length === 0) {
            return false;
        }
        return lineArr.every(item => !isNaN(parseFloat(item)) && isFinite(item));
    };

    return (
        <>
            <div aria-describedby={id} onClick={handleClick} title={tooltip}>
                {button}
            </div>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
            >
                <div style={{ padding: "10px", textAlign: "center" }}>{label}</div>
                <div style={{ padding: "20px" }}>
                    <TextField
                        label="Line ID"
                        name="lineId"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={handleTextTyping}
                        value={rosLineData.lineId}
                        style={{ marginTop: '15px', minWidth: '100%' }}
                        error={!!fieldErrors?.lineId}
                        helperText={fieldErrors?.lineId ? fieldErrors?.lineId : ""}
                    />
                    <TextField
                        label="Название"
                        name="name"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={handleTextTyping}
                        value={rosLineData.name}
                        style={{ marginTop: '15px', minWidth: '100%' }}
                        error={!!fieldErrors?.name}
                        helperText={fieldErrors?.name ? fieldErrors?.name : ""}
                    />
                    <TextField
                        label="Точки"
                        name="line"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={handleTextTyping}
                        value={rosLineData.line}
                        style={{ marginTop: '15px', minWidth: '100%' }}
                        multiline={true}
                        error={!!fieldErrors?.line}
                        helperText={fieldErrors?.line ? fieldErrors?.line : ""}
                        className={"ros-line-textarea"}
                    />
                    <br />
                    <CircleButtonsGroup
                        buttons={[
                            {
                                isSelected: false,
                                title: "Сохранить",
                                iconClassName: "ti ti-save stat-icon",
                                onClick: handleSave,
                            },
                            {
                                isSelected: false,
                                title: "Отмена",
                                iconClassName: "ti ti-close stat-icon",
                                onClick: handleClose,
                            },
                        ]}
                    />
                </div>
            </Popover>
        </>
    );
}